<template>
  <div id="NotarizationApproval">
    <eb-header>
      <eb-break-crumb slot="breakCrumb" />
    </eb-header>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">项目信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">项目名称</div>
            <div class="row-right">{{notarization.projectName}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">项目编号</div>
            <div class="row-right">{{notarization.projectCode}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">邮寄地址</span>
        </eb-panel-header>
        <div slot="body" style="margin-top:10px;">
          <div class="row-field">
            <div class="row-left">报告邮寄地址</div>
            <div class="row-right">{{notarization.reportReceiveAddress}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">联系人</div>
            <div class="row-right">{{notarization.contactMan}}</div>
          </div>
          <div class="row-field">
            <div class="row-left">电话/手机号码</div>
            <div class="row-right">{{notarization.contactPhone}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">鉴证信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">报告份数</div>
            <div class="row-right">{{notarization.reportNum}}份</div>
          </div>
          <div class="row-field">
            <div class="row-left">鉴证单位</div>
            <div class="row-right">{{notarization.verificationCompany}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">费用清单</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">鉴证费</div>
            <div class="row-right">{{notarization.verificationMoney}}.00元 &nbsp;
              <span class="font-red">(中选金额的万分之三，最低100元)</span>
            </div>
          </div>
          <div class="row-field">
            <div class="row-left">制作费及快递费</div>
            <div class="row-right">{{notarization.costMoney}}元 &nbsp;
              <span class="font-red">(100元/份)</span>
            </div>
          </div>
          <div class="row-field">
            <div class="row-left">总计</div>
            <div class="row-right">{{notarization.sumMoney}}元</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <div class="panel-box">
      <eb-panel>
        <eb-panel-header slot="header">
          <span slot="title">支付信息</span>
        </eb-panel-header>
        <div slot="body">
          <div class="row-field">
            <div class="row-left">
              <template v-if="notarization.payer == '1'">采购方支付</template>
              <template v-else>中选方支付</template>
            </div>
            <div class="row-right">{{notarization.payerOrgName}}</div>
          </div>
        </div>
      </eb-panel>
    </div>
    <div class="eb-line"></div>
    <el-form label-width="120px">
      <div class="panel-box">
        <eb-panel>
          <eb-panel-header slot="header">
            <span slot="title">鉴证状态及备注</span>
          </eb-panel-header>
          <div slot="body">
            <div class="row-field">
              <div class="row-left">鉴证状态</div>
              <div class="row-right">
                <el-radio-group v-model="notarization.payStatus">
                  <el-radio class="eb-radio radio" label="1">待付款</el-radio>
                  <el-radio class="eb-radio radio" label="2">待鉴证</el-radio>
                  <el-radio class="eb-radio radio" label="3">已鉴证</el-radio>
                  <el-radio class="eb-radio radio" label="4">驳回</el-radio>
                </el-radio-group>
              </div>
            </div>
            <div class="row-field">
              <div class="row-left">添加备注</div>
              <div class="row-right">
                <el-input type="textarea" v-model="notarization.description" :value="notarization.description" :rows="5" :maxlength="100" placeholder="发票备注" class="eb-textarea inputWidth"></el-input>
              </div>
            </div>
          </div>
        </eb-panel>
      </div>
      <div class="eb-line"></div>
      <div class="panel-box">
        <div class="eb-button-group width">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm()">取消</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmForm()">确认</el-button>
        </div>
      </div>
    </el-form>
  </div>
</template>
<script>
import ebHeader from '@/components/common/eb-header';
import ebBreakCrumb from '@/components/common/eb-break-crumb';
import ebPanel from '@/components/common/panel/eb-panel';
import ebPanelHeader from '@/components/common/panel/eb-panel-header';
import { findNotarizationById, updateNotarizationStatus } from '@/services/notarization/notarization-service';
export default {
  name: 'NotarizationApproval',
  components: {
    ebHeader,
    ebBreakCrumb,
    ebPanel,
    ebPanelHeader
  },
  data() {
    return {
      applyId: this.$route.params.applyId,
      notarization: {}
    };
  },
  created() {
    this.initNotarizationInfo();
  },
  methods: {
    async initNotarizationInfo() {
      try {
        let { data } = await findNotarizationById(this.applyId);
        if (data.returnCode === '01') {
          this.notarization = data;
        } else {
          this.$message.error('获取鉴证信息失败');
        }
      } catch (error) {
        this.$message.error(error.message);
      }
    },
    resetForm() {
      this.$router.push('/sys/notarization');
    },
    confirmForm() {
      this.updateNotarizationInfo();
    },
    async updateNotarizationInfo() {
      let params = {
        applyId: this.notarization.applyId,
        payStatus: this.notarization.payStatus,
        description: this.notarization.description
      };
      try {
        let { data } = await updateNotarizationStatus(params);
        if (data.returnCode === '01') {
          this.$message.success('信息已更新');
          this.$router.push('/sys/notarization');
        } else {
          this.$message.error('信息更新失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接!');
      }
    }
  }
};
</script>
<style lang="less" scoped>
#NotarizationApproval {
  .panel-box {
    width: 90%;
    margin: 0 auto;
    padding-top: 30px;
    padding-bottom: 30px;
    .inputWidth {
      width: 530px;
    }
    .radio {
      margin-right: 40px;
    }
    .width {
      margin-left: -250px;
    }
    .quoteMin {
      margin-left: 530px;
      padding: 10px 10px 0 0;
      color: #fb5b3b;
    }
  }
  .row-field {
    width: 100%;
    min-height: 35px;
    line-height: 35px;
    margin-left: 0px;
    font-family: '微软雅黑';
    display: flex;
    flex-wrap: wrap;
    margin-top: 5px;
    .row-left {
      width: 120px;
      margin-left: 0px;
      margin-right: 15px;
    }
    .row-left1 {
      width: 260px;
      margin-left: 0px;
      margin-right: 15px;
      text-align: right;
    }
    .row-right {
      width: 66%;
      padding-right: 15px;
      padding-left: 30px;
    }
  }
  .panel-handsontable {
    padding-top: 7px;
    margin-left: 0px;
  }
  .font-red {
    color: #fb5b3b;
  }
}
</style>
